module.exports = __webpack_public_path__ + "static/media/faq _(10).f23e91cd.gif";